export class User {
    idUser: number;
    name: string;
    cpf: string;
    email: string;
    phone: string;
    password: string;
    token: string;
    pro: number;
    admin: number;
    dtCreate: string;
    togglePayment: boolean;
    toggleAdmin: boolean;

    constructor() {
        this.toggleAdmin = false;
        this.togglePayment = false;
        this.pro = 0;
        this.admin = 0;
    }
}